import React, { useEffect } from 'react';
import { SeoBar } from '../components/SeoBar';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { HeroSection } from './newsletter/HeroSection';
import { Newsletters2021Section } from './newsletter/Newsletters2021Section';
import { Newsletters2020Section } from './newsletter/Newsletters2020Section';
import { Newsletters2019Section } from './newsletter/Newsletters2019Section';
export function NewsletterPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="min-h-screen w-full bg-white flex flex-col" data-id="element-3391">
      <SeoBar data-id="element-3392" />
      <Header data-id="element-3393" />
      <main className="flex-grow" data-id="element-3394">
        <div className="w-full bg-gray-50 pb-20" data-id="element-3395">
          <HeroSection data-id="element-3396" />
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12 space-y-12" data-id="element-3397">
            <Newsletters2021Section data-id="element-3398" />
            <Newsletters2020Section data-id="element-3399" />
            <Newsletters2019Section data-id="element-3400" />
          </div>
        </div>
      </main>
      <Footer data-id="element-3401" />
    </div>;
}